// Theme: gruvbox
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'gruvbox',
  name: 'GRUVBOX',
  tagline: 'GRUVBOX',
  description: 'Gruvbox classico com base quente e contraste retro confortavel.',
  category: 'retro-memory',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#282828', '#3C3836', '#D79921', '#EBDBB2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-gruvbox'
  },
  colorVars: {
    '--accent': '#D79921',
    '--accent-foreground': '#282828',
    '--background': '#282828',
    '--border': '#34312d',
    '--card': '#3C3836',
    '--card-border-active': 'rgba(215, 153, 33, 0.10)',
    '--card-completed': '#34302F',
    '--card-foreground': '#EBDBB2',
    '--card-glow': 'rgba(215, 153, 33, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#EBDBB2',
    '--hold-fill': '#D79921',
    '--input': '#34312d',
    '--modal-bg': '#282828',
    '--modal-border': '#34312d',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#34312d',
    '--muted-foreground': '#D9CCAA',
    '--nav-active': '#D79921',
    '--nav-bg': '#3C3836',
    '--popover': '#3C3836',
    '--popover-foreground': '#EBDBB2',
    '--primary': '#D79921',
    '--primary-foreground': '#282828',
    '--ring': '#D79921',
    '--secondary': '#34312d',
    '--secondary-foreground': '#EBDBB2',
    '--streak': '#D79921',
    '--success': '#22c55e',
    '--success-foreground': '#282828',
    '--xp': '#D79921',
    '--xp-bg': '#3C3836'
  },
  resolvedVars: {
    '--accent': '#D79921',
    '--accent-foreground': '#282828',
    '--accent-foreground-hsl': '0 0% 16%',
    '--accent-foreground-oklch': 'from #282828 l c h',
    '--accent-hsl': '40 73% 49%',
    '--accent-oklch': 'from #D79921 l c h',
    '--background': '#282828',
    '--background-hsl': '0 0% 16%',
    '--background-oklch': 'from #282828 l c h',
    '--border': '#34312d',
    '--border-hsl': '34 7% 19%',
    '--border-oklch': 'from #34312d l c h',
    '--border-w': '1px',
    '--card': '#3C3836',
    '--card-border-active': 'rgba(215, 153, 33, 0.10)',
    '--card-completed': '#34302F',
    '--card-completed-hsl': '12 5% 19%',
    '--card-completed-oklch': 'from #34302F l c h',
    '--card-foreground': '#EBDBB2',
    '--card-foreground-hsl': '43 59% 81%',
    '--card-foreground-oklch': 'from #EBDBB2 l c h',
    '--card-glow': 'rgba(215, 153, 33, 0.03)',
    '--card-hsl': '20 5% 22%',
    '--card-oklch': 'from #3C3836 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EBDBB2',
    '--foreground-hsl': '43 59% 81%',
    '--foreground-oklch': 'from #EBDBB2 l c h',
    '--hold-fill': '#D79921',
    '--hold-fill-hsl': '40 73% 49%',
    '--hold-fill-oklch': 'from #D79921 l c h',
    '--input': '#34312d',
    '--input-hsl': '34 7% 19%',
    '--input-oklch': 'from #34312d l c h',
    '--modal-bg': '#282828',
    '--modal-bg-hsl': '0 0% 16%',
    '--modal-bg-oklch': 'from #282828 l c h',
    '--modal-border': '#34312d',
    '--modal-border-hsl': '34 7% 19%',
    '--modal-border-oklch': 'from #34312d l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#34312d',
    '--muted-foreground': '#D9CCAA',
    '--muted-foreground-hsl': '43 38% 76%',
    '--muted-foreground-oklch': 'from #D9CCAA l c h',
    '--muted-hsl': '34 7% 19%',
    '--muted-oklch': 'from #34312d l c h',
    '--nav-active': '#D79921',
    '--nav-active-hsl': '40 73% 49%',
    '--nav-active-oklch': 'from #D79921 l c h',
    '--nav-bg': '#3C3836',
    '--nav-bg-hsl': '20 5% 22%',
    '--nav-bg-oklch': 'from #3C3836 l c h',
    '--popover': '#3C3836',
    '--popover-foreground': '#EBDBB2',
    '--popover-foreground-hsl': '43 59% 81%',
    '--popover-foreground-oklch': 'from #EBDBB2 l c h',
    '--popover-hsl': '20 5% 22%',
    '--popover-oklch': 'from #3C3836 l c h',
    '--primary': '#D79921',
    '--primary-foreground': '#282828',
    '--primary-foreground-hsl': '0 0% 16%',
    '--primary-foreground-oklch': 'from #282828 l c h',
    '--primary-hsl': '40 73% 49%',
    '--primary-oklch': 'from #D79921 l c h',
    '--radius': '16px',
    '--ring': '#D79921',
    '--ring-hsl': '40 73% 49%',
    '--ring-oklch': 'from #D79921 l c h',
    '--secondary': '#34312d',
    '--secondary-foreground': '#EBDBB2',
    '--secondary-foreground-hsl': '43 59% 81%',
    '--secondary-foreground-oklch': 'from #EBDBB2 l c h',
    '--secondary-hsl': '34 7% 19%',
    '--secondary-oklch': 'from #34312d l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#D79921',
    '--streak-hsl': '40 73% 49%',
    '--streak-oklch': 'from #D79921 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#282828',
    '--success-foreground-hsl': '0 0% 16%',
    '--success-foreground-oklch': 'from #282828 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(40 73% 49% / 0.15)',
    '--xp': '#D79921',
    '--xp-bg': '#3C3836',
    '--xp-bg-hsl': '20 5% 22%',
    '--xp-bg-oklch': 'from #3C3836 l c h',
    '--xp-hsl': '40 73% 49%',
    '--xp-oklch': 'from #D79921 l c h'
  }
}
